import { useMediaQuery as useMediaQueryVueUse } from '@vueuse/core'

type TailwindBreakpoint = 'sm' | 'md' | 'lg' | 'xl' | '2xl'

const breakpoints: Record<TailwindBreakpoint, string> = {
  sm: '800px',
  md: '1040px', // switch to desktop design
  lg: '1240px',
  xl: '1520px',
  '2xl': '1720px'
}

export function useMediaQuery (breakpoint: TailwindBreakpoint) {
  const query = `(min-width: ${breakpoints[breakpoint]})`
  return useMediaQueryVueUse(query)
}
